import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { UserEntity } from "../../api/models/fraud.models";
import { FraudService } from "../../api/services/fraud.service";
import { interval, Observable, switchMap, take, tap } from "rxjs";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserControllerService {
  public readonly user: WritableSignal<UserEntity | undefined> = signal<UserEntity | undefined>(undefined);
  private readonly _fraudService: FraudService = inject(FraudService);
  private readonly _router: Router = inject(Router);

  constructor() {
    this._autoUpdate();
  }

  getUser(): Observable<UserEntity | undefined> {
    return this._fraudService.getUserByInitData().pipe(tap((user: UserEntity): void => {
      if (user.blocked) {
        localStorage.getItem('authTelegramData') && localStorage.removeItem('authTelegramData');
        this._router.navigate(['401']);
        return;
      }
      this.user.set(user)
    }));
  }

  refresh(): void {
    this.getUser().pipe(take(1)).subscribe({
      next: () => {

      }
    });
  }

  private _autoUpdate(): void {
    const time: number = 10 * 1000;

    interval(time).pipe(
      switchMap(async () => this.refresh())
    ).subscribe({
      next: () => {
      },
      error: () => {
      }
    });
  }
}
